import i18n from 'i18n-js';
import { machineStatus as machineStatusConstants } from '@helpers';
import svgRegister from '@styles/icons/svg/svgRegister';
import { ACTIVE_MACHINE_ICON_ANIMATION_CONFIG } from '@v2/pages/machines/modules/now/components/Overview/constants';

export const getIconName = (status?: string): keyof typeof svgRegister => {
  switch (status) {
    case machineStatusConstants.CHANGE:
      return 'changeLiveScreen';
    case machineStatusConstants.SETUP:
      return 'setupLiveScreen';
    case machineStatusConstants.NOTPRODUCTIVE:
      return 'notProductiveLiveScreen';
    default:
      return ACTIVE_MACHINE_ICON_ANIMATION_CONFIG.activeIconName;
  }
};

export const getStatusDescription = (status?: string, subStatus?: string, executionMode?: string): string => {
  switch (status) {
    case machineStatusConstants.CHANGE:
      return i18n.t('Change of workpiece');
    case machineStatusConstants.SETUP:
    case machineStatusConstants.NOTPRODUCTIVE: {
      const sub = subStatus ? i18n.t(subStatus) : '';
      const exec = executionMode ? i18n.t(executionMode) : '';
      return sub && exec ? `${sub} · ${exec}` : sub || exec;
    }
    default:
      const machineStatus = status ? i18n.t(status) : '';
      return subStatus ? `${i18n.t('Machine is {{status}}', { status: `${i18n.t(machineStatus).toLowerCase()}` })}` : '';
  }
};

export const getShowExpectedEnd = (status?: string): boolean => status !== machineStatusConstants.NOTPRODUCTIVE;
